var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.41.744a.833.833 0 011.18 0L6 5.154l4.41-4.41a.833.833 0 111.18 1.179l-5 5a.833.833 0 01-1.18 0l-5-5a.833.833 0 010-1.179z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }